<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Zap Off" class="d-icon d-icon--zap-off" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><g :clip-path="`url(#${uniqueID}a)`" fill-rule="evenodd" clip-rule="evenodd" fill="currentColor"><path d="M6.699.541a.5.5 0 0 1 .297.52l-.295 2.376a.5.5 0 0 1-.992-.124l.085-.683-.125.15a.5.5 0 0 1-.768-.64L6.116.68a.5.5 0 0 1 .583-.139ZM7.33 5a.5.5 0 0 1 .5-.5h2.67a.5.5 0 0 1 .384.82L9.669 6.777a.5.5 0 0 1-.768-.641l.53-.635H7.83a.5.5 0 0 1-.5-.5Zm-1.446 6.32a.5.5 0 0 1-.88-.382l.43-3.438H1.5a.5.5 0 0 1-.384-.82l2.208-2.65L.646 1.355a.5.5 0 1 1 .708-.708l10 10a.5.5 0 0 1-.708.708L8.034 8.74l-2.15 2.58Zm.324-1.95.272-2.182.844.843L6.208 9.37ZM5.793 6.5H2.568l1.466-1.76L5.793 6.5Z"/></g><defs><clipPath :id="`${uniqueID}a`"><path fill="#fff" d="M0 0h12v12H0z"/></clipPath></defs></svg>
</template>

<script>
import { getUniqueString } from '@/src/utils';
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconZapOff',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
    this.uniqueID = getUniqueString();
  },
};
</script>
